import { Dialog } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useService } from '~/services/service.base';
import { DialogService } from '~/services/service.dialog';
import { IConfirmDeleteCreditCard } from '~/views/types';

export const RemoveCardDialog: FC<IConfirmDeleteCreditCard> = observer(props => {
    const dialogService = useService(DialogService);
    const { removeCardDialogSrv } = dialogService;

    const confirmRemove = () => {
        removeCardDialogSrv.handleClose();
        props.onConfirmDeleteCreditCard();
    };

    return (
        <Dialog open={removeCardDialogSrv.open} className="hr-modal-dialog">
            <div className="modal-dialog modal-dialog-centered remove-card-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={removeCardDialogSrv.handleClose}>
                            <figure>
                                <img src="/assets/img/modal-close-btn.svg" />
                            </figure>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="modalContent">
                            <h3>Remove this payment method?</h3>
                            <p>This will delete it from your account.</p>
                            <div className="rc-dialog-actions">
                                <button type="button" className="btn" onClick={confirmRemove}>
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
});
